import { render, staticRenderFns } from "./SendImage.vue?vue&type=template&id=65b7de1e&scoped=true&"
import script from "./SendImage.vue?vue&type=script&lang=ts&"
export * from "./SendImage.vue?vue&type=script&lang=ts&"
import style0 from "./SendImage.vue?vue&type=style&index=0&id=65b7de1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b7de1e",
  null
  
)

export default component.exports